export const RouterPath = {
  HOME: "/",
  AUTH: "/auth",
  CHAT: "/chat",
  CHAT_DETAIL: "/chat/:conversationId",
  COPILOT: "/copilot",
  COPILOT_DETAIL: "/copilot/:spaceId",
  LOGIN: "/login",
  SIGNUP: "/sign-up",
  SIGNUP_MAIL_SENT: "/sign-up/mail-sent",
  SIGNUP_CONFIRM_EMAIL: "/confirm-email",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_MAIL_SENT: "/password-forgot/mail-sent",
  RESET_PASSWORD: "/reset-password",
  PASSWORD_CHANGED: "/reset-password/password-changed",
  LINK_NOT_VALID: "/link-not-valid",
  MAILHOG: "/mailhog",
  FLOWER: "/flower",
  MATOMO: "/matomo",
  CGU: "/cgu",
  AIDE_PAGE: "/aide/:id",
  BILLING: "/billing",
  BILLING_SUCCESS: "/billing/success",
  BILLING_CANCEL: "/billing/cancel",
  ADMIN_REFRESH_TOKENS: "/admin/refresh-tokens",
  PROFILE: "/profile",
  NOTIFICATION: "/notification",
};
Object.freeze(RouterPath);
